import React from "react";

import {Button } from "@blueprintjs/core";
import { ButtonVariant } from "common/views/button/Button.view";
import { IDataTableColumn } from "common/views/table/DataTable";
import {FavoriteSearch} from "../entities/FavoriteSearch";
import { IconNames } from "@blueprintjs/icons";
import MutationButton from "common/views/button/MutationButton";
import { MutationType } from "typegraph";
import Icon from "common/views/icon/Icon";


export const name: IDataTableColumn<FavoriteSearch, any> = {
	name: "name",
	sort: "name",
	label: { k: "col.name", v: "Search Name" },
	component: fav => {
		if (!fav.name) {
			return null;
		}

		return <span>{fav.name}</span>;
	}
};

export const numberOfItems: IDataTableColumn<FavoriteSearch, any> = {
	name: "count",
	sort: "count",
	label: { k: "col.count", v: "# Content Items" },
	component: fav => {
		if (!fav.count) {
			return 0;
		}

		return <span>{fav.count}</span>;
	}
};

export const actions: IDataTableColumn<FavoriteSearch, any> = {
	name: "actions",
	sort: "actions",
	label: { k: "col.actions", v: "Actions" },
	component: fav => (
		<div>
			<Button
				small={true}
				onClick={() => {
					location.href =
						window.location.origin +
						fav.query +
						"&searchid=" +
						fav.id;
				}}
			>
				<Icon icon={IconNames.EYE_OPEN} />
			</Button>

			<MutationButton
				variant={ButtonVariant.PRIMARY}
				viewKey="favorite.search.delete"
				clazz={FavoriteSearch}
				params={{ id: fav.id }}
				clearCacheOnSuccess={true}
				method={MutationType.DELETE}
			>
				<Icon icon={IconNames.TRASH} />
			</MutationButton>
		</div>
	)
};



// WEBPACK FOOTER //
// ./src/panels/favorites/fragments/FavoriteSearchFragments.tsx